import { render, staticRenderFns } from "./TagsField.vue?vue&type=template&id=74ae3060&scoped=true"
import script from "./TagsField.vue?vue&type=script&lang=ts"
export * from "./TagsField.vue?vue&type=script&lang=ts"
import style0 from "./TagsField.vue?vue&type=style&index=0&id=74ae3060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae3060",
  null
  
)

export default component.exports